import { Link, useRouteError } from 'react-router-dom';

import { Container } from '../components/primitives/Container';

function useSafeRouteError(): { status?: number; statusText?: string } | undefined {
  try {
    return useRouteError() as { status?: number; statusText?: string } | undefined;
  } catch {
    return undefined;
  }
}

export default function NotFound() {
  const error = useSafeRouteError();
  const status = error?.status ?? 404;
  return (
    <Container>
      <section
        style={{
          padding: '96px 0',
          textAlign: 'center',
          fontFamily: 'var(--font-serif)',
        }}
      >
        <p
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 12,
            letterSpacing: '0.16em',
            opacity: 0.6,
          }}
        >
          STATUS · {status}
        </p>
        <h1 style={{ fontSize: 84, margin: '12px 0', letterSpacing: '-0.02em' }}>
          Not found.
        </h1>
        <p style={{ color: 'var(--text-2)' }}>
          We couldn&apos;t find that page. <Link to="/">Back home</Link>.
        </p>
      </section>
    </Container>
  );
}
